<form [formGroup]="connectionForm">
    <div class="title" mat-dialog-title>Connect Pubmatic</div>
    <div class="dialog-body">
        <div class="body-content">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Username</mat-label>
                <input type="text" matInput placeholder="Enter Username" formControlName="username"
                    data-cy="pubmatic-username-input">
                <mat-error *ngIf="connectionForm.get('username').hasError('required')">This field is
                    required</mat-error>
            </mat-form-field>
            
            <div class="password-field-wrapper">
                <div class="password-field">
                    <mat-form-field appearance="outline" class="form-field pwd-field">
                        <mat-label>Password</mat-label>
                        <input type="password" matInput placeholder="Enter Password" formControlName="password"
                            data-cy="pubmatic-password-input" style="width: 100%;">
                        <mat-error *ngIf="connectionForm.get('password').hasError('required')">This field is
                            required</mat-error>
                    </mat-form-field>
                </div>
                <div class="verify-status-container">
                    <span *ngIf="verificationStatus === 'success'" class="verify-status success" matTooltip="Verification successful"
                        matTooltipPosition="above">
                        <mat-icon>check_circle</mat-icon>
                    </span>
                    <span *ngIf="verificationStatus === 'failed'" class="verify-status failed"
                        matTooltip="Verification failed" matTooltipPosition="above">
                        <mat-icon>cancel</mat-icon>
                    </span>
                </div>
            </div>
            <div class="verify-btn-wrapper">
                <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="fetchOrganizations()"
                    [disabled]="loading" data-cy="pubmatic-dialog-fetch-orgs-btn">
                    <span *ngIf="!loading">Verify</span>
                    <span *ngIf="loading">Loading...</span>
                </button>
            </div>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Organization ID</mat-label>
                <mat-select multiple [formControl]="selectedOrganizationIds" [disabled]="organizations.length === 0"
                    data-cy="pubmatic-org-select">
                    <mat-option *ngFor="let org of organizations" [value]="org.id">
                        {{org.name}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="selectedOrganizationIds.hasError('required')">Please select an
                    organization</mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="dialog-footer">
        <div>
            <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()"
                [disabled]="loading || organizations.length === 0" data-cy="pubmatic-dialog-connect-data-btn">
                <span *ngIf="!loading">Connect</span>
                <span *ngIf="loading">Connecting...</span>
            </button>
        </div>
    </div>
</form>